<template>
    <div class="execution-tab mb-xl">
        <AonSpinner
            v-if="entityStore.loadingEntity"
            class="m-auto"
            :scale="0.5"
            color="castleMoat"
        />
        <div v-else class="card-holder">
            <AonContainer>
                <AonRow class="">
                    <AonCol class="grid-cols-12 p-0">
                        <KnowledgeExchangeCard class="mb-xl" />
                        <InnovationTrendByProductCard class="mb-xl" />
                        <InnovationTrendCard class="mb-xl" />
                        <TopInventorsCard class="mb-xl" />
                    </AonCol>
                </AonRow>
            </AonContainer>
        </div>
    </div>
</template>

<script setup>
import { watch, onMounted } from 'vue'
import { useEntityStore } from '@/stores'

import TopInventorsCard from './TopInventorsCard.vue'
import InnovationTrendCard from './InnovationTrendCard.vue'
import InnovationTrendByProductCard from './InnovationTrendByProductCard.vue'
import KnowledgeExchangeCard from './KnowledgeExchangeCard.vue'

const entityStore = useEntityStore()

onMounted(async () => {})
</script>

<style lang="scss" scoped>
.execution-tab {
    width: 100%;
    position: relative;
}
</style>
